import React from 'react';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { APP_CONFIG } from '@/config/constants';

export const Login: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="mx-auto h-12 w-12 rounded-lg bg-primary flex items-center justify-center">
            <span className="text-primary-foreground font-bold text-xl">A</span>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            {APP_CONFIG.NAME}
          </h2>
        </div>

        {/* Login Form */}
        <LoginForm className="mt-8" />

        {/* Footer */}
        <div className="text-center">
          <p className="text-xs text-gray-500">
            Don't have an account?{' '}
            <a
              href="/signup"
              className="font-medium text-primary hover:text-primary/80"
            >
              Contact support to get started
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
